import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  TextField,
  Button,
  Typography,
  Paper,
} from '@mui/material';
import axios from 'axios';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Check if already logged in
    const userData = localStorage.getItem('userData');
    if (userData) {
      navigate('/dashboard');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    try {
      const response = await axios.post('https://permit-hkgwaph0hsfhcvh6.canadacentral-01.azurewebsites.net/api/login', {
        username,
        password,
      });
      
      if (response.data.success) {
        // Store user data in localStorage
        localStorage.setItem('userData', JSON.stringify({
          username: response.data.user.username,
          email: response.data.user.email,
          name: response.data.user.name,
          role: response.data.user.role
        }));
        
        // Force navigation to dashboard
        window.location.href = '/dashboard';
      } else {
        setError('Invalid credentials');
      }
    } catch (err) {
      setError('Invalid credentials');
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 12,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography 
          component="h1" 
          variant="h4" 
          sx={{ 
            mb: 1, 
            fontWeight: 700,
            background: 'linear-gradient(45deg, #2563eb 30%, #3b82f6 90%)',
            backgroundClip: 'text',
            textFillColor: 'transparent',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          Donut Naturales
        </Typography>
        <Typography 
          variant="subtitle1" 
          sx={{ 
            mb: 4,
            color: 'text.secondary',
            textAlign: 'center'
          }}
        >
          Sign in to access your account
        </Typography>
        <Paper
          elevation={2}
          sx={{
            p: 4,
            width: '100%',
            borderRadius: 3,
            bgcolor: 'background.paper',
          }}
        >
          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="username"
              label="Username"
              name="username"
              autoComplete="username"
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                },
              }}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                },
              }}
            />
            {error && (
              <Typography color="error" sx={{ mt: 2, textAlign: 'center' }}>
                {error}
              </Typography>
            )}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              sx={{
                mt: 3,
                mb: 2,
                height: 48,
                fontSize: '1rem',
                borderRadius: 2,
                textTransform: 'none',
                background: 'linear-gradient(45deg, #2563eb 30%, #3b82f6 90%)',
                boxShadow: '0 3px 5px 2px rgba(37, 99, 235, .15)',
                '&:hover': {
                  background: 'linear-gradient(45deg, #1d4ed8 30%, #2563eb 90%)',
                },
              }}
            >
              Sign in
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login; 